import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

class AdminFileSizesListHeader extends PureComponent {
  changeOrder(e, field) {
    const {
      order,
      handleChangeOrder,
    } = this.props;

    e.preventDefault();
    handleChangeOrder(field, order === 'asc' ? 'desc' : 'asc');
  }

  render() {
    const {
      intl,
      orderBy,
      order,
    } = this.props;

    return (
      <tr>
        <th className={`th-sortable${orderBy === 'name' ? ' active' : ''}`}>
          <a href="#sort" onClick={(e) => { this.changeOrder(e, 'name'); }}>
            {intl.formatMessage({ defaultMessage: 'Name' })}
            {' '}
            {orderBy === 'name' && (
              <i className={`fas fa-long-arrow-${order === 'asc' ? 'down' : 'up'}`} />
            )}
          </a>
        </th>
        <th>
          {intl.formatMessage({ defaultMessage: 'Dimensions' })}
        </th>
        <th>
          {intl.formatMessage({ defaultMessage: 'Crop' })}
        </th>
        <th>
          {' '}
        </th>
      </tr>
    );
  }
}

AdminFileSizesListHeader.propTypes = {
  intl: PropTypes.object.isRequired,
  orderBy: PropTypes.string.isRequired,
  order: PropTypes.string.isRequired,
  handleChangeOrder: PropTypes.func.isRequired,
};

export default injectIntl(AdminFileSizesListHeader);
